import { render, staticRenderFns } from "./InviteCollaboratorPopover.vue?vue&type=template&id=3442734c&scoped=true"
import script from "./InviteCollaboratorPopover.vue?vue&type=script&lang=ts"
export * from "./InviteCollaboratorPopover.vue?vue&type=script&lang=ts"
import style0 from "./InviteCollaboratorPopover.vue?vue&type=style&index=0&id=3442734c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442734c",
  null
  
)

export default component.exports